import FormControlLabelComponent from "../../../../shared/components/form-control-label/FormControlLabelComponent";
import "./ProfileBasicDetailsComponent.scss";
import {useSelector} from "react-redux";
import {IRootReducerState} from "../../../../store/reducers";
import DataLabelValueComponent from "../../../../shared/components/data-label-value/DataLabelValueComponent";
import moment from "moment";
import MaskTextComponent from "../../../../shared/components/mask-text/MaskTextComponent";
import React, {useCallback} from "react";
import {CommonService} from "../../../../shared/services";
import CardV2Component from "../../../../shared/components/card-v2/CardV2Component";
import HorizontalLineV2Component from "../../../../shared/components/horizontal-line-v2/HorizontalLineV2Component";
import PageHeaderComponent from "../../../../shared/components/page-header/PageHeaderComponent";
import {useNavigate} from "react-router-dom";
import LinkComponent from "../../../../shared/components/link/LinkComponent";

interface ProfileBasicDetailsComponentProps {

}

const ProfileBasicDetailsComponent = (props: ProfileBasicDetailsComponentProps) => {
    const {
        clientBasicDetails,
    } = useSelector((state: IRootReducerState) => state.client);
    const [isSSNMasked, setIsSSNMasked] = React.useState<boolean>(true);
    const navigate = useNavigate();

    const navigateToEdit = useCallback(() => {
        navigate(CommonService._client.NavigateToClientEdit("basicDetails"));

    }, [navigate]);

    return (
        <div className={'profile-basic-details-component'}>
            <div className={'profile-details-wrapper'}>
                    <PageHeaderComponent title={'My Profile'} className={'profile-details-header'} actions={
                        <LinkComponent className={'edit-profile-button'} onClick={navigateToEdit}>(Edit)</LinkComponent>
                    }/>
                <div className={'profile-details-content'}>
                    <CardV2Component title={'Personal Details'} >
                        <div className="ts-row">
                            <div className="ts-col-md-6 ts-col-lg-4">
                                <DataLabelValueComponent className={'patient-name'} label={'First Name'}>
                                    {clientBasicDetails?.first_name || "N/A"}
                                </DataLabelValueComponent>
                            </div>
                            <div className="ts-col-md-6 ts-col-lg-4">
                                <DataLabelValueComponent className={'patient-name'} label={'Last Name'}>
                                    {clientBasicDetails?.last_name || "N/A"}
                                </DataLabelValueComponent>
                            </div>

                            <div className="ts-col-md-6 ts-col-lg-4">
                                <DataLabelValueComponent label={'Date of Birth'}>
                                    {clientBasicDetails?.dob ? moment(clientBasicDetails?.dob).format('DD-MMM-YYYY') : "N/A"}
                                </DataLabelValueComponent>
                            </div>
                            <div className="ts-col-md-6 ts-col-lg-4">
                                <DataLabelValueComponent label={'Gender'}>
                                    {clientBasicDetails?.gender_details?.title || "N/A"}
                                </DataLabelValueComponent>
                            </div>

                            <div className="ts-col-md-6 ts-col-lg-4">
                                {
                                    clientBasicDetails?.ssn ?
                                        <DataLabelValueComponent label={`SSN ${isSSNMasked ? '(Click to view)' : ''}`}>
                                            <MaskTextComponent value={clientBasicDetails?.ssn || 'N/A'}
                                                               onToggle={setIsSSNMasked}/>
                                        </DataLabelValueComponent> :
                                        <DataLabelValueComponent label={'SSN'}>
                                            {clientBasicDetails?.ssn || "N/A"}
                                        </DataLabelValueComponent>
                                }
                            </div>
                            <div className="ts-col-md-6 ts-col-lg-4">
                                <DataLabelValueComponent label={'Nickname/Preferred Name'}>
                                    {clientBasicDetails?.nick_name || "N/A"}
                                </DataLabelValueComponent>
                            </div>
                        </div>
                    </CardV2Component>
                    <HorizontalLineV2Component/>
                    <CardV2Component title={'Contact Information'}
                                     >
                        <div className="ts-row">
                            <div className="ts-col-8">
                                <FormControlLabelComponent label={'Primary Phone:'}/>
                                <div className={'ts-row'}>
                                    <div className={'ts-col-6'}>
                                        <DataLabelValueComponent label={'Phone Type'}>
                                            {clientBasicDetails?.primary_contact_info?.phone_type_details?.title || "N/A"}
                                        </DataLabelValueComponent>
                                    </div>
                                    <div className={'ts-col-6'}>
                                        <DataLabelValueComponent label={'Phone Number'}>
                                            {clientBasicDetails?.primary_contact_info?.phone ? CommonService.formatPhoneNumber(clientBasicDetails?.primary_contact_info?.phone) : "N/A"}
                                        </DataLabelValueComponent>
                                    </div>
                                </div>
                            </div>
                            <div className="ts-col-4">
                                <FormControlLabelComponent label={'Primary Email:'}/>
                                <div className={'ts-row'}>
                                    <div className={'ts-col-12'}>
                                        <DataLabelValueComponent label={'Email'}>
                                            {clientBasicDetails?.primary_email || "N/A"}
                                        </DataLabelValueComponent>
                                    </div>

                                </div>
                            </div>
                        </div>
                        <div className="ts-row">
                            {(clientBasicDetails?.secondary_contact_info?.length > 0 && (clientBasicDetails.secondary_contact_info[0]?.phone !== "" || clientBasicDetails?.secondary_emails?.[0]?.email !== "")) && (
                                <div className="ts-col-8">
                                    {clientBasicDetails?.secondary_contact_info?.some((contact: any) => contact?.phone !== "") && (
                                        <div>
                                            <FormControlLabelComponent label={'Alternate Phone:'}/>
                                        </div>
                                    )}
                                    {clientBasicDetails?.secondary_contact_info?.map((phone_number: any, index: number) => (
                                        <>
                                            {phone_number?.phone_type_details?.title && phone_number?.phone && (
                                                <div className={'ts-row'}>
                                                    <div className={'ts-col-6'}>
                                                        <DataLabelValueComponent label={'Phone Type'}>
                                                            {phone_number.phone_type_details.title || "N/A"}
                                                        </DataLabelValueComponent>
                                                    </div>
                                                    <div className={'ts-col-6'}>
                                                        <DataLabelValueComponent label={'Phone Number'}>
                                                            {CommonService.formatPhoneNumber(phone_number?.phone || 'N/A')}
                                                        </DataLabelValueComponent>
                                                    </div>
                                                </div>
                                            )}
                                        </>
                                    ))}
                                </div>
                            )}

                            {clientBasicDetails?.secondary_emails?.length > 0 && clientBasicDetails?.secondary_emails?.[0]?.email !== "" && (
                                <div className="ts-col-4">
                                    <>
                                        <FormControlLabelComponent label={'Alternate Email:'}/>
                                    </>
                                    <div className={'ts-row'}>
                                        {clientBasicDetails?.secondary_emails?.map((email: any, index: number) => (
                                            <>
                                                {email?.email && (
                                                    <div className={'ts-col-12'}>
                                                        <DataLabelValueComponent label={'Email'}>
                                                            {email.email}
                                                        </DataLabelValueComponent>
                                                    </div>
                                                )}
                                            </>
                                        ))}
                                    </div>
                                </div>
                            )}
                        </div>

                    </CardV2Component>
                    <HorizontalLineV2Component/>

                    <CardV2Component title={'Address Information'}
                                     >
                        {clientBasicDetails?.address?.address_line ?
                            <DataLabelValueComponent label={'Address'}>
                                <>
                                    {clientBasicDetails.address.address_line}, {clientBasicDetails.address.city}, {clientBasicDetails.address.state}, {clientBasicDetails.address.country},{clientBasicDetails.address.zip_code}
                                </>

                            </DataLabelValueComponent> :
                            <DataLabelValueComponent label={'Address'}>
                                N/A
                            </DataLabelValueComponent>
                        }
                    </CardV2Component>
                    <HorizontalLineV2Component/>
                    <CardV2Component
                                     title={'Emergency Contact Information'}>
                        <FormControlLabelComponent className={'primary-emergency-contact'}
                                                   label={'Primary Emergency Contact'}/>
                        <div className={'ts-row'}>
                            <div className={'ts-col-lg-4'}>
                                <DataLabelValueComponent label={'Full Name'}>
                                    {clientBasicDetails?.emergency_contact_info?.primary_emergency?.name || "N/A"}
                                </DataLabelValueComponent>
                            </div>
                            <div className={'ts-col-lg-4'}>
                                <DataLabelValueComponent label={'Relationship'}>
                                    {clientBasicDetails?.emergency_contact_info?.primary_emergency?.relationship_details?.title || "N/A"}
                                </DataLabelValueComponent>
                            </div>
                            <div className={'ts-col-lg-4'}>
                                <DataLabelValueComponent label={'Language'}>
                                    {clientBasicDetails?.emergency_contact_info?.primary_emergency?.language_details?.title || "N/A"}
                                </DataLabelValueComponent>
                            </div>
                        </div>
                        <div className={'ts-row'}>
                            <div className="ts-col-8">
                                <FormControlLabelComponent label={'Primary Phone:'}/>
                                <div className={'ts-row'}>
                                    <div className={'ts-col-6'}>
                                        <DataLabelValueComponent label={'Phone Type'}>
                                            {clientBasicDetails?.emergency_contact_info?.primary_emergency?.primary_contact_info?.phone_type_details?.title || "N/A"}
                                        </DataLabelValueComponent>
                                    </div>
                                    <div className={'ts-col-6'}>
                                        <DataLabelValueComponent label={'Phone Number'}>
                                            {clientBasicDetails?.emergency_contact_info?.primary_emergency?.primary_contact_info?.phone ? CommonService.formatPhoneNumber(clientBasicDetails?.emergency_contact_info?.primary_emergency?.primary_contact_info?.phone) : "N/A"}
                                        </DataLabelValueComponent>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {
                            clientBasicDetails?.emergency_contact_info?.primary_emergency?.secondary_contact_info?.length > 0 &&
                            clientBasicDetails?.emergency_contact_info?.primary_emergency?.secondary_contact_info[0]?.phone !== "" &&
                            <HorizontalLineV2Component marginBottom={true}/>
                        }
                        <div className="ts-row">
                            <div className="ts-col-8">
                                {clientBasicDetails?.emergency_contact_info?.primary_emergency?.secondary_contact_info?.length > 0 &&
                                    clientBasicDetails?.emergency_contact_info?.primary_emergency?.secondary_contact_info[0]?.phone !== "" &&
                                    <FormControlLabelComponent label={'Alternate Phone:'}/>
                                }
                                {
                                    clientBasicDetails?.emergency_contact_info?.primary_emergency?.secondary_contact_info?.map((phone_number: any, index: number) => {
                                        return <>

                                            {
                                                phone_number?.phone_type_details?.title && phone_number?.phone && <>
                                                    <div className={'ts-row'}>
                                                        <div className={'ts-col-6'}>
                                                            <DataLabelValueComponent label={'Phone Type'}>
                                                                {phone_number?.phone_type_details?.title || "N/A"}
                                                            </DataLabelValueComponent>
                                                        </div>
                                                        <div className={'ts-col-6'}>
                                                            <DataLabelValueComponent label={'Phone Number'}>
                                                                {CommonService.formatPhoneNumber(phone_number?.phone || "N/A")}
                                                            </DataLabelValueComponent>
                                                        </div>
                                                    </div>
                                                </>
                                            }
                                        </>
                                    })
                                }
                            </div>
                        </div>
                        {clientBasicDetails?.emergency_contact_info?.secondary_emergency?.name && <>
                            <HorizontalLineV2Component marginBottom={true}/>
                            <FormControlLabelComponent className={'secondary-emergency-contact'}
                                                       label={'Secondary Emergency Contact'}/>
                            <div className={'ts-row'}>
                                <div className={'ts-col-lg-4'}>
                                    <DataLabelValueComponent label={'Full Name'}>
                                        {clientBasicDetails?.emergency_contact_info?.secondary_emergency?.name || "N/A"}
                                    </DataLabelValueComponent>
                                </div>
                                <div className={'ts-col-lg-4'}>
                                    <DataLabelValueComponent label={'Relationship'}>
                                        {clientBasicDetails?.emergency_contact_info?.secondary_emergency?.relationship_details?.title || "N/A"}
                                    </DataLabelValueComponent>
                                </div>
                                <div className={'ts-col-lg-4'}>
                                    <DataLabelValueComponent label={'Language'}>
                                        {clientBasicDetails?.emergency_contact_info?.secondary_emergency?.language_details?.title || "N/A"}
                                    </DataLabelValueComponent>
                                </div>
                            </div>
                            {
                                clientBasicDetails?.emergency_contact_info?.secondary_emergency?.primary_contact_info?.phone_type_details?.title && clientBasicDetails?.emergency_contact_info?.secondary_emergency?.primary_contact_info?.phone &&
                                <>
                                    <FormControlLabelComponent label={'Primary Phone:'}/>
                                    <div className={'ts-row'}>
                                        <div className={'ts-col-lg-4'}>
                                            <DataLabelValueComponent label={'Phone Type'}>
                                                {clientBasicDetails?.emergency_contact_info?.secondary_emergency?.primary_contact_info?.phone_type_details?.title || "N/A"}
                                            </DataLabelValueComponent>
                                        </div>
                                        <div className={'ts-col-lg-4'}>
                                            <DataLabelValueComponent label={'Phone Number'}>
                                                {CommonService.formatPhoneNumber(clientBasicDetails?.emergency_contact_info?.secondary_emergency?.primary_contact_info?.phone || "N/A")}
                                            </DataLabelValueComponent>
                                        </div>
                                    </div>
                                </>
                            }
                            {clientBasicDetails?.emergency_contact_info?.secondary_emergency?.secondary_contact_info?.length > 0 &&
                                clientBasicDetails?.emergency_contact_info?.secondary_emergency?.secondary_contact_info[0]?.phone !== "" &&
                                <>
                                    <HorizontalLineV2Component marginBottom={true}/>
                                    <FormControlLabelComponent label={'Alternate Phone:'}/>
                                </>
                            }
                            {
                                clientBasicDetails?.emergency_contact_info?.secondary_emergency?.secondary_contact_info?.map((phone_number: any, index: number) => {
                                    return <>
                                        {
                                            phone_number?.phone_type_details?.title && phone_number?.phone && <>
                                                <div className={'ts-row'}>
                                                    <div className={'ts-col-lg-4'}>
                                                        <DataLabelValueComponent label={'Phone Type'}>
                                                            {phone_number?.phone_type_details?.title || "N/A"}
                                                        </DataLabelValueComponent>
                                                    </div>
                                                    <div className={'ts-col-lg-4'}>
                                                        <DataLabelValueComponent label={'Phone Number'}>
                                                            {CommonService.formatPhoneNumber(phone_number?.phone || "N/A")}
                                                        </DataLabelValueComponent>
                                                    </div>
                                                </div>
                                            </>
                                        }
                                    </>
                                })
                            }
                        </>}
                    </CardV2Component>
                    <HorizontalLineV2Component/>
                    <CardV2Component title={'Work Information'}>
                        <div className={'ts-row'}>
                            <div className={'ts-col-lg-4'}>
                                <DataLabelValueComponent label={'Occupation'}>
                                    {clientBasicDetails?.work_info?.occupation || 'N/A'}
                                </DataLabelValueComponent>
                            </div>
                            <div className={'ts-col-lg-4'}>
                                <DataLabelValueComponent label={'Employment Status'}>
                                    {clientBasicDetails?.work_info?.employment_status_details?.title || 'N/A'}<br/>
                                </DataLabelValueComponent>
                            </div>
                        </div>
                    </CardV2Component>
                </div>
            </div>
        </div>
    );

};

export default ProfileBasicDetailsComponent;
